var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('PcHeader'),_c('div',{staticClass:"container-inner"},[_vm._v(" 求购信息 ")]),_c('PcFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }